// src/utils/notification.js
import { ElNotification } from 'element-plus'
import { h } from 'vue'
import Notification from '@/NewLibrary/Notification.vue'

export function notify({ type = 'info', title = '', message = '', duration = 4000, showClose = false, zIndex }) {
  return ElNotification({
    message: h(Notification, {
      type,
      title,
      message
    }),
    duration: duration,
    showClose: showClose,
    // Forwarded so callers can lift the notification above modal overlays
    // (el-dialog and el-notification otherwise share the same z-index pool).
    ...(zIndex != null && { zIndex }),
  })
}

// The Apollo error link (src/graphql/client/shared-links.js) already notifies the user for
// network errors and for every GraphQL error except the Z_InputError class, which it
// deliberately swallows. Callers that catch a rejected mutation use this to surface the
// swallowed case without double-notifying for errors the link has already reported.
export function notifyUnreportedError(error, title = 'Something went wrong') {
  const graphQLErrors = error?.graphQLErrors || []
  const alreadyNotified =
    Boolean(error?.networkError) ||
    graphQLErrors.some(e => e?.extensions?.sub_error_type !== 'Z_InputError')

  if (alreadyNotified) return

  notify({
    type: 'error',
    title,
    message: graphQLErrors[0]?.message || error?.message || 'Please try again.',
    duration: 8000,
  })
}
